/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgTeamsChat = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8 0a8 8 0 1 1-3.613 15.14l-.121-.065-3.645.91a.5.5 0 0 1-.62-.441v-.082l.014-.083.91-3.644-.063-.12a7.95 7.95 0 0 1-.83-2.887l-.025-.382L0 8a8 8 0 0 1 8-8Zm0 1a7 7 0 0 0-6.106 10.425.5.5 0 0 1 .063.272l-.014.094-.756 3.021 3.024-.754a.502.502 0 0 1 .188-.01l.091.021.087.038A7 7 0 1 0 8 1Zm.5 8a.5.5 0 0 1 .09.992L8.5 10h-3a.5.5 0 0 1-.09-.992L5.5 9h3Zm2-3a.5.5 0 0 1 .09.992L10.5 7h-5a.5.5 0 0 1-.09-.992L5.5 6h5Z",
        fill: "#6264A7"
    }));
export default SvgTeamsChat;
